import { useEffect, useState } from 'react';
import { addDays, dateKeyOf, instantAt, type DateKey } from './lane-time';

/**
 * Today on `timeZone`'s calendar, moved on at each midnight there -- for
 * a screen that follows today (the calendar with no day in its URL) and
 * must not wait for some other re-render to notice the day has changed,
 * without re-rendering every minute to find out (`useMinuteNow` does
 * that for the lanes alone).
 */
export function useTodayKey(timeZone: string): DateKey {
  const [today, setToday] = useState(() => dateKeyOf(Date.now(), timeZone));
  useEffect(() => {
    let timer: number | undefined;
    const schedule = () => {
      const now = Date.now();
      const key = dateKeyOf(now, timeZone);
      setToday(key);
      const midnight = instantAt(addDays(key, 1), 0, timeZone);
      // A little past it, so the clock read then is on the new day.
      timer = window.setTimeout(schedule, Math.max(1_000, midnight - now + 50));
    };
    schedule();
    return () => window.clearTimeout(timer);
  }, [timeZone]);
  return today;
}
